// removed by extract-text-webpack-plugin
module.exports = {"skfadingcircle":"_6eUyfZlo6a4H4lhpScMc7","skcircle":"_3x4JSZupCyLkm2UGGVAwOx","skcircleFadeDelay":"gbaCIYk8Ck2DjF42zBCnR","skcircle2":"JCAvILI20bqqu5S_oFMki","skcircle3":"_2SEW4nB0_z0Nn-K2pNFnIp","skcircle4":"_3ZHfirb_SmW69czhQwXqWa","skcircle5":"_3Tmh7JQce8VbkPl-_4R9nT","skcircle6":"_1XXirc159JWDZv5OqBiKOe","skcircle7":"_5Fun1PFvu46yW8_W8k_P-","skcircle8":"_1fyWdxq5AAj7eu4MsJqqXX","skcircle9":"_2Al6SIqadfPqoPeaDYXgnk","skcircle10":"_3uWq3g2RnFqBg-Jb5Agr8i","skcircle11":"f6JnVWAdzujEobATVOsk-","skcircle12":"_17YlfWQZ9l5CSTNrji1lmn"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Spinner/FadingCircle/style.css
// module id = 1354
// module chunks = 0